export default "__VITE_ASSET__DCDRcNVC__"